import { InternalLink } from '@/components/Clickables/InternalLink/InternalLink';
import { Container } from '@/components/Container/Container';
import { Heading } from '@/components/Heading/Heading';
import { Text } from '@/components/Text/Text';

export function ClientError() {
  return (
    <Container className="flex justify-center" style={{ minHeight: '60vh' }}>
      <div className="my-16" style={{ maxWidth: '800px' }}>
        <Heading as="h1" className="mb-4">
          Something went wrong
        </Heading>
        <Text>Darn.</Text>
        <Text>You have encountered an error. Here are some things you can try:</Text>
        <ul className="m-0 list-disc p-4">
          <li>
            Go back to the <InternalLink to="/">homepage.</InternalLink>
          </li>
          <li>Refresh the page.</li>
          <li>
            If the error persists, please send us an email at{' '}
            <a href="mailto:support@fishbrain.com">support@fishbrain.com</a> and let us know.
          </li>
        </ul>
        <Text>Thanks!</Text>
      </div>
    </Container>
  );
}
